module.exports = __webpack_public_path__ + "img/plateImg2.ee059204.png";